export enum cardTypes {
    extendedCard, wideCard, basicCard, basicCardExtended, loginCard, subNavCard, wideCardExtended, moduleCard,
    dashboardCard
}